import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import TermsComp from '../Components/termssection/TermsComp'

function TermsLayout() {
  return (
    <>
    <Header />
    <TermsComp />
    <Footer />
    </>
  )
}

export default TermsLayout